import moment from "moment";
import FrontifyIcon from "assets/icons/frontify.logo.svg";

const formatDate = (date: Date) => {
  const dateformt = "M/d/Y h:mma";
  return moment(date).format(dateformt);
};

const getUser = (cred: { admin: boolean }) => {
  if (cred.admin) return "Admin";
  return null;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isManagedLibraryCollection = (collection: any) => {
  if (collection?.frontifyMeta) {
    return {
      isManagedCollection: true,
      platformName: "Frontify",
      PlatformIcon: FrontifyIcon,
    };
  }

  return {
    isManagedCollection: false,
  };
};

export { formatDate, getUser, isManagedLibraryCollection };
